import { unreachable } from '../../../../ts-utils';
import { RESOURCE_COMPONENT_UNMOUNTED, RESOURCE_COMPONENT_MOUNTED, } from './lifecycle-actions';
export const lifecycleReducer = (state, action) => {
    switch (action.type) {
        case RESOURCE_COMPONENT_UNMOUNTED:
            if (action.payload.disableResourceCleanup) {
                if (state?.type === 'READY') {
                    return {
                        ...state,
                        componentState: 'HIDDEN',
                        effects: undefined,
                    };
                }
                return state;
            }
            return undefined;
        case RESOURCE_COMPONENT_MOUNTED:
            if (state?.type === 'READY') {
                return {
                    ...state,
                    componentState: 'VISIBLE',
                    effects: {
                        someoneIsTyping: 'none',
                    },
                };
            }
            return state;
        default:
            throw unreachable(action);
    }
};
//# sourceMappingURL=lifecycle-reducer.js.map